import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'

import { Observable, map } from 'rxjs'

import { ApiHttpService } from '@flowx/designer/shared/api/api-http.service'

import { Message, MessageRequest, SendFeedbackPayload } from '../../types/agent.dictionary'

@Injectable({ providedIn: 'root' })
export class AgentChatApi extends ApiHttpService {
  #agentBuilder = `agent-builder/api/v1/workflows`

  constructor() {
    super(inject('BASE_URL' as any), inject(HttpClient))
  }

  sendFeedback(payload: SendFeedbackPayload): Observable<string> {
    const { reason, feedbackType, message, requestId, sessionId } = payload

    return this.post(`${this.#agentBuilder}/${payload.agentId}/feedback`, {
      feedback: {
        reason,
        response: feedbackType,
        user_message: message,
      },
      request_id: requestId,
      session_id: sessionId,
    })
  }

  getAgentResponse(payload: MessageRequest): Observable<Omit<Message, 'author' | 'feedback'>> {
    const { agentId, ...body } = payload
    return this.streamArray(`${this.#agentBuilder}/chat/${agentId}/sse`, body).pipe(
      map((response: any) => {
        if (response) {
          return response
        }
        try {
          const responseObj = JSON.parse(response)

          if (responseObj?.detail?.error_message) {
            throw new Error(responseObj.detail.error_message)
          }
        } catch (e) {
          return e ?? response
        }
      }),
      map((answer_object) => ({
        ...answer_object,
      }))
    )
  }
}
